/**
 * What only the buyer's phone knows about itself, for the issuer's 3DS2 risk
 * check (SWRN-2092). The commit request is made by the webQR server, so without
 * this Tranzzo sees the server — and an unknown device is more often sent to a
 * challenge. User-Agent, Accept and IP are added server-side from the request.
 */
export interface BrowserFingerprintDto {
    language: string;
    color_depth: number;
    screen_width: number;
    screen_height: number;
    /** Minutes UTC is ahead of local time, as `getTimezoneOffset` reports it (Kyiv summer time → -180). */
    tz_offset: number;
    java_enabled: boolean;
}

export const collectBrowserFingerprint = (): BrowserFingerprintDto => ({
    language: navigator.language,
    color_depth: window.screen.colorDepth,
    screen_width: window.screen.width,
    screen_height: window.screen.height,
    tz_offset: new Date().getTimezoneOffset(),
    java_enabled: navigator.javaEnabled?.() ?? false,
});
